module.exports = __webpack_public_path__ + "static/media/access_220.bf342dc8.ico";